import styled from 'styled-components'

export const Container = styled.div<any>`
  width: 100%;
  img {
    width: 100%;
    margin: 30px 0 50px 0;
  }
`
